// External Imports
import { h } from 'preact';
import { IconGlobe, Inline } from '@lessonnine/design-system.lib';
import tokens from '@lessonnine/design-tokens.lib/dist/json/variables.json';

// Internal Imports
import { displayedLanguage } from '../../constants/learnLanguages';
import { DisclosureMenuLink } from '../DisclosureMenu/DisclosureMenuLink';
import { DisclosureMenu } from '../DisclosureMenu/DisclosureMenu';
import { useStore } from '../../state/context';

// Local variables
const displayLanguageLinks = {
  Deutsch: 'https://de.babbel.com/live?locale=de',
  English: 'https://www.babbel.com/live?locale=en',
  Español: 'https://es.babbel.com/live?locale=es',
  Français: 'https://fr.babbel.com/live?locale=fr',
  Italiano: 'https://it.babbel.com/live?locale=it',
  Polski: 'https://pl.babbel.com/live?locale=pl',
  Português: 'https://pt.babbel.com/live?locale=pt',
  Svenska: 'https://se.babbel.com/live?locale=sv',
};

// Component Definition
function DisplayLanguage() {
  const state = useStore();
  const locale = process.env.LOCALE;
  const currentLanguage = displayedLanguage[locale];
  const { t } = state;

  const items = Object.entries(displayLanguageLinks).map(
    ([displayLanguage, link]) =>
      currentLanguage !== displayLanguage && (
        <DisclosureMenuLink href={link} key={displayLanguage}>
          {displayLanguage}
        </DisclosureMenuLink>
      ),
  );

  return (
    <Inline alignItems="center" gap={parseInt(tokens.space.x2, 10)}>
      <IconGlobe />
      <DisclosureMenu
        ariaLabel={t.nav.display_language}
        items={items.filter(Boolean)}
        label={currentLanguage}
        navLabelId={{ button: true }}
      />
    </Inline>
  );
}

export { DisplayLanguage };
